export default {
    language: "Português (Portugal)",
    StripeSuccess: {
        loading: "A processar o seu pagamento...",
        successMessage: "A sua subscrição foi ativada com sucesso!",
        processingError: "Falha no processamento do pagamento, contacte-nos",
    },
    UserDetail: {
        userInfo: {
            emailLabel: "E-mail",
            createdAt: "Criado em",
            noRecord: "Sem registos",
            loginTime: "Hora de login",
        },
        orders: {
            title: "Histórico de encomendas",
            loading: "A carregar...",
            refresh: "Atualizar",
            orderAmount: "Valor",
            points: "Pontos",
            createdAt: "Criado em",
            orderType: "Tipo",
            status: "Estado",
            noOrders: "Sem encomendas",
            goToSubscription: "Comprar pontos",
            freeCredit: "Crédito gratuito",
            paidCredit: "Crédito pago",
            queryOrderFailed: "Falha ao consultar encomenda",
            statusPaid: "Pago",
            statusPending: "Pendente",
            statusCancelled: "Cancelado",
            statusDeactivated: "Desativado",
            checkoutUrlNotAvailable: "Falha ao obter URL de pagamento",
            verifyingPayment: "A verificar estado do pagamento...",
            paymentSuccess: "Pagamento bem-sucedido",
            paymentPending: "A encomenda está pendente de pagamento, por favor complete o pagamento",
            paymentFailed: "Pagamento falhou ou foi cancelado",
            paymentStatus: "Estado do pagamento",
            paymentStatusDescription: "Completou o pagamento?",
            cancelPayment: "Cancelar pagamento",
            completedPayment: "Pagamento concluído",
            warning: "Aviso",
            confirmCancelOrder: "Tem a certeza que deseja cancelar esta encomenda? Esta ação não pode ser desfeita.",
            cancel: "Cancelar",
            confirm: "Confirmar",
            cancellingOrder: "A cancelar encomenda...",
            orderCancelledSuccess: "Encomenda cancelada",
            cancelOrderFailed: "Falha ao cancelar encomenda",
            checkOrderStatusFailed: "Falha ao verificar estado da encomenda",
            promptClick: "Clique no estado \"Pendente\" para continuar o pagamento",
        }
    },
    UserFeedback: {
        title: "Testemunhos de Utilizadores",
        feedback: "Ouça avaliações reais de criadores e profissionais de todo o mundo sobre a nossa tecnologia de processamento de imagens com IA.",
        people: [
            {
                id: 1,
                avatar: "feedback-user-avatar-1.jpg",
                name: "Sr. Lin",
                profession: "Editor de vídeo e criador de conteúdos",
                rating: 5,
                comment: "Incrível! O ClixMagicAI é super rápido! Carregue um vídeo com marca de água e em minutos terá uma versão sem marca de água, sem qualquer perda de qualidade. Uma ferramenta essencial para remover marcas de água!"
            },
            {
                id: 2,
                avatar: "feedback-user-avatar-2.jpg",
                name: "Sra. Su",
                profession: "Especialista em redes sociais",
                rating: 5,
                comment: "O ClixMagicAI salvou a minha biblioteca de conteúdos do Instagram! Identifica com precisão marcas de água complexas, o processamento de margens é muito mais refinado do que outros programas e o resultado final parece mais natural."
            },
            {
                id: 3,
                avatar: "feedback-user-avatar-3.jpg",
                name: "Sr. Chen",
                profession: "Produtor de conteúdos para vídeos curtos",
                rating: 5,
                comment: "A remoção de marcas de água com o ClixMagicAI é super conveniente. Processo material do TikTok durante o trajeto para o trabalho e descarrego a versão em HD assim que chego ao escritório. Duplica a eficiência! Uma bênção para profissionais de multimédia."
            },
            {
                id: 4,
                avatar: "feedback-user-avatar-4.jpg",
                name: "Sr. Huang",
                profession: "Designer gráfico e diretor criativo visual",
                rating: 5,
                comment: "Como designer, estou muito satisfeito! Ao processar imagens de exemplo com logótipos fornecidas pelos clientes, a textura de fundo é restaurada naturalmente, sem vestígios de Photoshop, poupando muito tempo de pós-processamento."
            },
            {
                id: 5,
                avatar: "feedback-user-avatar-5.jpg",
                name: "Sra. Emily",
                profession: "Criadora de conteúdos digitais freelancer",
                rating: 5,
                comment: "Encontrei um tesouro! O preço da subscrição é muito mais barato que outros produtos de remoção de marca de água no mercado, mas o efeito é ainda melhor, especialmente ao processar marcas de água transparentes com gradiente."
            },
            {
                id: 6,
                avatar: "feedback-user-avatar-6.jpg",
                name: "Sr. Robertson",
                profession: "Desenvolvedor de cursos de formação empresarial",
                rating: 5,
                comment: "O ClixMagicAI é muito conveniente por não precisar de instalação! O meu computador da empresa tem restrições de permissão para instalar software, agora posso processar material de curso apenas com o navegador, a qualquer hora e em qualquer lugar."
            },
            {
                id: 7,
                avatar: "feedback-user-avatar-7.jpg",
                name: "Sra. Zhou",
                profession: "Dona de casa e editora de conteúdos comunitários",
                rating: 5,
                comment: "A interface é tão simples que até a minha avó conseguiria usar! Se não tem tempo para aprender programas profissionais como Photoshop, experimente o ClixMagicAI. Perfeito para utilizadores iniciantes como eu. Haha~"
            },
            {
                id: 8,
                avatar: "feedback-user-avatar-8.jpg",
                name: "Sr. Johnson",
                profession: "Estrategista visual de e-commerce",
                rating: 5,
                comment: "O ClixMagicAI é super poderoso, pode remover imagens, vídeos, pequenos objectos, pessoas, texto e muito mais. Funcionalidades completas, recomendo a todos~"
            },
            {
                id: 9,
                avatar: "feedback-user-avatar-9.jpg",
                name: "Sra. Fang",
                profession: "Entusiasta de fotografia e partilhadora de conteúdos online",
                rating: 5,
                comment: "Uau~ Finalmente encontrei uma ferramenta de remoção de marca de água que não degrada a qualidade da imagem! Mágico como um feitiço~ Editar fotos já não é um problema! Recomendo fortemente!!!"
            },
            {
                id: 10,
                avatar: "feedback-user-avatar-10.jpg",
                name: "Sr. Williams",
                profession: "Instrutor de educação online",
                rating: 5,
                comment: "O recurso de memória de posição da marca de água é super útil! Ao processar vídeos de séries de cursos, não preciso selecionar repetidamente, poupa pelo menos meia hora de trabalho e aumenta significativamente a minha eficiência na preparação de aulas."
            }
        ]
    },
    Order: {
        purchasePoints: "Comprar Pontos",
        subtitle: "Escolha um pacote de pontos adequado para desfrutar do serviço de remoção de marca de água",
        loginReminderDesc: "Inicie sessão para selecionar e comprar pontos",
        freeTag: "Gratuito",
        freePlan: "Plano Gratuito",
        autoActivated: "Ativado automaticamente após login",
        points: "Pontos",
        autoIncluded: "Presente gratuito",
        discount: "Desconto",
        purchase: "Comprar Agora",
        paymentStatusDescription: "Completou o pagamento?",
        paymentNotCompleted: "Pagamento não concluído",
        queryOrderFailed: "Falha ao verificar estado da encomenda",
        cancelPayment: "Cancelar Pagamento",
        completedPayment: "Pagamento Concluído",
        warning: "Aviso",
        confirmCancelOrder: "Tem a certeza que deseja cancelar esta encomenda? Esta ação não pode ser revertida.",
        cancel: "Cancelar",
        confirm: "Confirmar",
        selectProductFirst: "Selecione um pacote primeiro",
        creatingOrder: "A criar encomenda...",
        orderCreated: "Encomenda criada com sucesso",
        createOrderFailed: "Falha ao criar encomenda",
        checkoutUrlNotAvailable: "Falha ao obter link de pagamento",
        cancellingOrder: "A cancelar encomenda...",
        orderCancelledSuccess: "Encomenda cancelada",
        cancelOrderFailed: "Falha ao cancelar encomenda",
        verifyingPayment: "A verificar estado do pagamento...",
        paymentSuccess: "Pagamento bem-sucedido",
        paymentPending: "Encomenda a aguardar pagamento, por favor conclua o pagamento",
        paymentFailed: "Pagamento falhou ou foi cancelado",
        checkOrderStatusFailed: "Falha ao verificar estado da encomenda",
        quickStart: "Início Rápido",
        shortTerm: "Uso de Curto Prazo",
        recommended: "Recomendado",
        bestValue: "Melhor Valor",
    },
    Login: {
        title: "Iniciar Sessão",
        subtitle: "Login rápido com contas sociais",
        memberTip: "Inicie sessão para desfrutar de mais funcionalidades",
        types: [
            {
                id: 1,
                provider: "github",
                icon: "fab fa-github",
                desc: "Iniciar sessão com GitHub"
            },
            {
                id: 2,
                provider: "google",
                icon: "fab fa-google",
                desc: "Iniciar sessão com Google"
            }
        ],
        error: {
            serverError: "Erro no servidor, tente novamente mais tarde",
            networkError: "Erro de rede, verifique a sua ligação"
        }
    },
    OAuthCallback: {
        loading: "A processar pedido de login",
        pleaseWait: "Aguarde, a verificar informações de login...",
        error: "Falha no login",
        backToHome: "Voltar para a Página Inicial",
        success: "Login bem-sucedido",
        redirecting: "A redirecionar para a página inicial..."
    },
    Nav:{
        title: "ClixMagicAI",
        logo: "logo.png",
        menu: {
            pricing: "Preços",
            faq: "Perguntas Frequentes",
        },
        login: "Iniciar Sessão",
        userMenu: {
            account: "Conta",
            logout: "Terminar Sessão",
            credit: "Pontos",
            freeCredit: "Gratuito",
            paidCredit: "Comprados",
            nextUpdate: "Próxima atualização de pontos",
            language: "Idioma",
            theme: "Tema",
        },
        userMenuIcons: {
            account: "fas fa-user-circle",
            logout: "fas fa-sign-out-alt",
            credit: "fas fa-credit-card",
            language: "fas fa-globe",
            theme: "fas fa-moon",
        },
    },
    ProductAdv: {
        title: "Funcionalidades do ClixMagicAI",
        advs: [
            {
                title: "Motor de Reconhecimento por IA: Deteção Automática de Elementos Intrusivos",
                desc: "Baseado em algoritmos de aprendizagem profunda, identifica automaticamente marcas de água, texto, rostos e elementos complexos em imagens/vídeos, sem necessidade de marcação manual. Suporta formatos do Instagram, TikTok e outras plataformas, com proteção rigorosa de dados privados.",
                beforeImage: "adv-before-1.jpg",
                afterImage: "adv-after-1.jpg",
                click: "Remover Marca de Água"
            },
            {
                title: "Mestre em Limpeza de Imagens: Remove Logótipos/Carimbos de Data Rapidamente, Mantendo a Qualidade",
                desc: "Remove com precisão marcas de água de marcas, datas de captura, autocolantes e outros elementos indesejados. A IA restaura automaticamente a textura do fundo, as imagens processadas parecem naturais como o original, perfeitas para publicações em redes sociais.",
                beforeImage: "adv-before-2.jpg",
                afterImage: "adv-after-2.jpg",
                click: "Remover Marca de Água"
            },
            {
                title: "Removedor de Marcas de Água Dinâmicas: Apaga Legendas Rolantes/Logótipos de Plataformas",
                desc: "Remova com um clique cartões finais do YouTube, marcas de água do TikTok e textos rolantes. A IA rastreia e processa cada fotograma, produzindo vídeos 4K de alta qualidade fluidos, suporta formatos MP4/MOV e outros formatos populares.",
                beforeImage: "adv-before-3.jpg",
                afterImage: "adv-after-3.jpg",
                click: "Remover Marca de Água"
            }
        ]
    },
    Description:{
        title: "ClixMagicAI",
        desc: "Uma ferramenta profissional com IA para remover marcas de água de imagens, vídeos e PDFs rapidamente e com facilidade, fornecendo resultados naturais.",
        fileTypes: {
            image: "Remover Marca de Água de Imagem",
            pdf: "Remover Marca de Água de PDF",
            video: "Remover Marca de Água de Vídeo"
        },
        marketingTags: [
            { id: "freeTrialTag", text: "Teste Gratuito Diário", icon: "fa-gift" },
            { id: "imageTag", text: "Remoção de Marca de Água de Imagem", icon: "fa-image" },
            { id: "videoTag", text: "Remoção de Marca de Água de Vídeo", icon: "fa-video" },
            { id: "aiPoweredTag", text: "Com IA", icon: "fa-robot" },
            { id: "noRegTag", text: "Login e Uso", icon: "fa-user-check" },
        ],
        videoPromt: "Em breve!",
        videoDesc: "Estamos a desenvolver o recurso de remoção de marca de água de vídeo para oferecer uma experiência ainda melhor."
    },
    Footer: {
        social: {
            title: "Contacte-nos",
            logo: "logo.png",
            methods:[
                {
                    icon: "x-platform-icon",
                    link: "https://x.com/ClixMagicAI"
                },
                {
                    icon: "far fa-envelope",
                    link: "mailto:support@clixmagic.com",
                    text: "support@clixmagic.com"
                },
            ]
        },
        termsTitle: "Termos Legais",
        terms: [
            {
                id: 1,
                title: "Política de Privacidade",
                link: "/privacy"
            },
            {
                id: 2,
                title: "Termos de Serviço",
                link: "/terms"
            },
            {
                id: 3,
                title: "Política de Cookies",
                link: "/cookie"
            }
        ],
        copyright: "© 2025 ClixMagicAI Todos os direitos reservados."
    },
    Task: {
        image: {
            imageSupportText: "Suporta formatos jpg, jpeg, png, webp, heic, heif, máximo 10MB por ficheiro",
            imageFileTooLarge: "Tamanho do ficheiro excede o limite (máx 10MB)",
            invalidImageType: "Formato de imagem não suportado, envie JPG, JPEG, PNG, WEBP, HEIC ou HEIF",
            imageWillCost: "Custará: 1 ponto",
            hiecSupportText: "Formatos HEIC/HEIF serão convertidos automaticamente para PNG ao enviar",
            hiecSuccess: "Formato HEIC/HEIF convertido com sucesso",
            hiecFailed: "Falha na conversão do formato HEIC/HEIF",
            processingImageTip: "A processar a sua imagem, aguarde...",
            guide: {
                title: "Guia de Utilização",
                step1: "Envie uma imagem",
                step2: "Pinte a área da marca de água ou deixe o modelo detetar automaticamente",
                step3: "Clique em enviar"
            }
        },
        common: {
            remaining: "Pontos restantes",
            nextUpdate: "Próxima atualização de pontos",
            handleError: "Erro ao processar ficheiro, tente outro ficheiro",
            uploadFailed: "Falha no upload do ficheiro",
            dragText: "Arraste ficheiros aqui ou",
            clickText: "clique para upload",
            loginRequired: "Inicie sessão antes de enviar ficheiros",
            noRemainingTasks: "Os seus pontos acabaram",
            loginNow: "Iniciar Sessão Agora",
            upgradeNow: "Comprar Pontos Agora",
            taskSubmitSuccess: "Tarefa enviada com sucesso",
            taskSubmitError: "Falha ao enviar tarefa",
            taskRetrySuccess: "Nova tentativa da tarefa enviada com sucesso!",
            taskRetryError: "Falha ao enviar nova tentativa da tarefa!",
            processing: "A processar",
            submit: "Enviar",
            waiting: "A aguardar",
            completed: "Concluído",
            failed: "Falhou",
            cancelled: "Cancelado",
            url_not_found: "Falha ao obter link",
            deleted: "Eliminado",
            refreshSuccess: "Lista de tarefas atualizada",
            refreshFailed: "Falha ao atualizar lista de tarefas",
            deleteSuccess: "Tarefa eliminada com sucesso",
            deleteFailed: "Falha ao eliminar tarefa",
            waitingForCompletion: "Aguarde a conclusão da tarefa atual antes de tentar novamente",
            loadOriginalImageFailed: "Falha ao carregar imagem original, tente novamente",
            downloadFailed: "Download falhou",
            startingDownload: "A iniciar download...",
            noTasks: "Sem tarefas",
            refresh: "Atualizar",
            sort: "Ordenar",
            noFilterTasks: "Sem tarefas {filter}",
            compare: "Ver comparação",
            originalImage: "Imagem original",
            processedImage: "Imagem processada",
            dragToCompare: "👈 Arraste para comparar 👉",
            cancel: "Cancelar",
            delete: "Eliminar",
            retry: "Tentar novamente",
            download: "Download",
            createAt: "Criado em",
            expiredAt: "Expira em",
        },
        video: {
            videoSupportText: "Suporta formatos mp4, mov, avi, mkv, máximo 100MB por ficheiro",
            videoFileTooLarge: "Tamanho do ficheiro excede o limite (máx 100MB)",
            invalidVideoType: "Formato de vídeo não suportado, envie MP4, MOV, AVI ou MKV",
            videoWillCost: "Custará: 3 pontos",
            processingVideoTip: "A processar o seu vídeo, aguarde...",
            guide: {
                step1: "Envie um vídeo",
                step2: "Selecione o tipo de marca de água e defina a área",
                step3: "Clique em enviar"
            },
            annotationTools: "Ferramentas de Anotação",
            selectType: "Selecione o Tipo",
            deleteAnnotation: "Eliminar Anotação",
            clearAllAnnotations: "Limpar Todas",
            annotationHelp: "Ajuda",
            dragTip: "Arraste para desenhar área",
            resizeTip: "Redimensione para ajustar",
            moveTip: "Anotações podem ser movidas",
            processing: "A processar",
            submit: "Enviar",
            taskSubmitSuccess: "Tarefa enviada com sucesso",
            taskSubmitError: "Falha ao enviar tarefa",
            retryTaskTip: "Nova tentativa enviada com sucesso",
            retryFailed: "Nova tentativa falhou",
            uploadFailed: "Upload falhou",
            staticWatermarkDesc: "Para marcas de água estáticas em posição fixa",
            normalWatermarkDesc: "Para marcas de água fixas normais",
            dynamicWatermarkDesc: "Para marcas de água dinâmicas que variam",
            moveWatermarkDesc: "Para marcas de água que precisam ser movidas"
        },
    },
    Router: {
        home: "Início",
        terms: "Termos de Serviço",
        privacy: "Política de Privacidade",
        cookie: "Política de Cookies",
        user: "Centro de Utilizador",
    },
    FAQ: {
        title: "Guia de Utilização e Perguntas Frequentes do ClixMagicAI",
        prompt: "Tem algum problema ou dúvida? Contacte-nos a qualquer momento: support@clixmagic.com",
        questions: [
            {
                id : 1,
                question: "O que é o ClixMagicAI e como funciona?",
                answer: "ClixMagicAI é uma ferramenta avançada de remoção de marcas de água com tecnologia de IA. Suporta o reconhecimento automático de marcas de água em imagens e vídeos, e oferece a função de marcação manual de posições de marcas de água. Para imagens, suporta vários formatos de conversão e garante saída de alta qualidade; para vídeos, pode processar marcas de água estáticas, dinâmicas e até as que mudam de forma."
            },
            {
                id : 2,
                question: "O ClixMagicAI oferece utilização gratuita?",
                answer: "Sim, oferecemos um serviço básico gratuito de 3 pontos diários! Pode utilizá-los para processar imagens (consumindo 1 ponto por operação) ou vídeos (consumindo 3 pontos por operação). Além disso, pode comprar pontos adicionais, que são válidos permanentemente."
            },
            {
                id : 3,
                question: "Posso comprar pontos adicionais?",
                answer: "Certamente! Além dos 3 pontos gratuitos atribuídos diariamente, pode adquirir pontos adicionais através das nossas opções de compra. Os pontos comprados serão válidos permanentemente, sem data de expiração."
            },
            {
                id : 4,
                question: "Quais os formatos de ficheiro suportados?",
                answer: "Para imagens, suportamos formatos PNG, JPEG, JPG, WEBP, HEIC e HEIF, com HEIC e HEIF a serem automaticamente convertidos para PNG. Para vídeos, suportamos vários formatos, incluindo MP4 e MOV."
            },
            {
                id : 5,
                question: "Como é protegida a minha privacidade?",
                answer: "No ClixMagicAI, valorizamos muito a privacidade do utilizador. Todos os ficheiros enviados são processados com encriptação e automaticamente eliminados dentro de 24 horas após o processamento. Não armazenamos nenhum ficheiro do utilizador ou informações relacionadas."
            },
            {
                id : 6,
                question: "Como posso iniciar sessão no ClixMagicAI?",
                answer: "Suportamos início de sessão rápido via contas GitHub ou Google, garantindo a segurança da sua conta enquanto simplificamos o processo de registo."
            },
            {
                id : 7,
                question: "Qual é a velocidade de processamento?",
                answer: "Graças aos nossos servidores de alto desempenho e algoritmos de IA otimizados, a maioria das tarefas de remoção de marca de água de imagens pode ser concluída em 10 segundos, enquanto a remoção de marca de água de vídeo pode demorar apenas 1 minuto no mínimo. O tempo real pode variar dependendo do tamanho e complexidade do ficheiro."
            },
            {
                id : 8,
                question: "Como é o resultado após o processamento?",
                answer: "Os nossos modelos de IA são extensivamente treinados para remover inteligentemente marcas de água de imagens e vídeos, mantendo a qualidade do conteúdo original. Seja reconhecida automaticamente ou marcada manualmente, a marca de água é efetivamente removida, garantindo resultados finais naturais e sem vestígios."
            },
            {
                id : 9,
                question: "Qual é o período de validade de cada tarefa?",
                answer: "Uma vez concluída a tarefa, os ficheiros processados serão mantidos no ClixMagicAI por 24 horas para download. Após expirar, os ficheiros serão automaticamente eliminados dos nossos servidores para proteger a sua privacidade."
            },
            {
                id : 10,
                question: "Qual é o limite máximo de tamanho de ficheiro?",
                answer: "Aceitamos ficheiros de imagem com tamanho máximo de 10MB e ficheiros de vídeo com tamanho máximo de 100MB. Ficheiros que excedam estes limites podem precisar de ser comprimidos ou cortados antes do envio."
            }
        ]
    },
    Terms: {
        "tabs": {
            "terms": "Termos de Serviço",
            "privacy": "Política de Privacidade",
            "cookies": "Política de Cookies"
        },
        "lastUpdated": "Última atualização: 20 de maio de 2025",
        "terms": {
            "sections": [
                {
                    "title": "1. Introdução",
                    "description": "Bem-vindo ao ClixMagicAI. A utilização dos nossos serviços implica a aceitação destes Termos de Serviço. Por favor, leia-os atentamente."
                },
                {
                    "title": "2. Descrição do Serviço",
                    "description": "ClixMagicAI oferece ferramentas com tecnologia de IA para remover marcas de água de imagens, vídeos e PDFs. Os nossos serviços são adequados para os seguintes usos legais:",
                    "items": [
                        "Remoção de marcas de água do seu próprio conteúdo",
                        "Remoção de marcas de água de conteúdo que tenha o direito apropriado de modificar",
                        "Para fins educacionais e de investigação"
                    ]
                },
                {
                    "title": "3. Responsabilidades do Utilizador",
                    "description": "Ao utilizar o ClixMagicAI, concorda que:",
                    "items": [
                        "Apenas enviará conteúdo que seja seu ou que tenha o direito apropriado de modificar",
                        "Não utilizará os nossos serviços para qualquer finalidade ilegal ou para violar qualquer lei",
                        "Não tentará contornar as nossas medidas de segurança ou limitações de uso",
                        "Não utilizará os nossos serviços para infringir os direitos de propriedade intelectual de terceiros"
                    ]
                },
                {
                    "title": "4. Termos da Conta",
                    "description": "Poderá precisar de criar uma conta para utilizar algumas funcionalidades dos nossos serviços. Para iniciar sessão, pode utilizar a sua conta Google ou GitHub. É responsável por:",
                    "items": [
                        "Manter a segurança da sua conta",
                        "Todas as atividades que ocorrem sob a sua conta",
                        "Fornecer informações de conta precisas (incluindo avatar, e-mail, nome de utilizador e ID de utilizador)"
                    ]
                },
                {
                    "title": "5. Serviços Gratuitos e Pagos",
                    "description": "ClixMagicAI oferece uma cota básica gratuita e opções flexíveis de compra de pontos para acesso às nossas funcionalidades de remoção de marca de água:",
                    "items": [
                        "Cota básica: Cada utilizador receberá automaticamente 3 pontos gratuitos por dia, utilizáveis para processamento de conteúdo",
                        "Regras de consumo de pontos: A remoção de marca de água de imagem consome 1 ponto por operação, a remoção de marca de água de vídeo consome 3 pontos por operação",
                        "Compra de pontos: Pode comprar pacotes de pontos para utilização adicional, todos os pontos comprados são permanentemente válidos, sem limitações de expiração",
                        "Política de reembolso: Devido à natureza instantânea e virtual dos serviços digitais, os pontos comprados com sucesso não são reembolsáveis"
                    ]
                },
                {
                    "title": "6. Direitos de Propriedade Intelectual",
                    "description": "Os serviços ClixMagicAI, incluindo todo o software, design e conteúdo criados por nós, são nossa propriedade intelectual. Sem permissão, não pode copiar, modificar ou criar trabalhos derivados baseados nos nossos serviços."
                },
                {
                    "title": "7. Limitação de Responsabilidade",
                    "description": "ClixMagicAI fornece os serviços \"tal como estão\", sem garantias de qualquer tipo. Não somos responsáveis por quaisquer danos resultantes da sua utilização dos nossos serviços."
                },
                {
                    "title": "8. Alterações aos Termos",
                    "description": "Podemos modificar estes termos a qualquer momento. Continuar a utilizar o ClixMagicAI após alterações nos termos constitui a sua aceitação dos termos revistos."
                },
                {
                    "title": "9. Rescisão",
                    "description": "Reservamo-nos o direito de terminar ou suspender imediatamente o seu acesso aos nossos serviços, sem aviso prévio, se acreditarmos que a sua conduta viola estes termos ou é prejudicial para outros utilizadores, para nós ou para terceiros."
                },
                {
                    "title": "10. Lei Aplicável",
                    "description": "Estes termos serão regidos pelas leis aplicáveis no local de registo da nossa empresa, sem considerar as disposições de conflito de leis."
                }
            ]
        },
        "privacy": {
            "sections": [
                {
                    "title": "1. Introdução",
                    "description": "No ClixMagicAI, valorizamos a sua privacidade e estamos comprometidos em proteger os seus dados pessoais. Esta Política de Privacidade explica como recolhemos, utilizamos e protegemos as suas informações quando utiliza o nosso website e serviços. Ao aceder ao nosso website ou utilizar qualquer serviço, concorda com as práticas de processamento de dados descritas nesta política. Cumprimos os regulamentos de proteção de dados aplicáveis."
                },
                {
                    "title": "2. Informações que Recolhemos",
                    "description": "Podemos recolher os seguintes tipos de informação:",
                    "items": [
                        { "bold": "Informações de conta", "text": "Avatar de utilizador, endereço de e-mail, nome de utilizador e ID de utilizador fornecidos ao iniciar sessão através do Google ou GitHub" },
                        { "bold": "Dados de utilização", "text": "Informações sobre como utiliza os nossos serviços, incluindo funcionalidades acedidas e tempos de utilização" },
                        { "bold": "Conteúdo enviado", "text": "Imagens, vídeos ou PDFs que envia para processamento" },
                        { "bold": "Informações de pagamento", "text": "Informações de pagamento ao comprar subscrições (processadas com segurança por gateways de pagamento de terceiros como Creem/Stripe/PayPal, mantemos apenas um registo do estado do pagamento)" },
                        { "bold": "Dados técnicos", "text": "Endereço IP, tipo de navegador, informações do dispositivo" }
                    ]
                },
                {
                    "title": "3. Como Utilizamos as Suas Informações",
                    "description": "Utilizamos as suas informações para:",
                    "items": [
                        { "text": "Fornecer, manter e melhorar os nossos serviços" },
                        { "text": "Processar e concluir transações" },
                        { "text": "Enviar notificações técnicas e mensagens de suporte" },
                        { "text": "Responder aos seus comentários e perguntas" },
                        { "text": "Analisar padrões de utilização para melhorar a experiência do utilizador, e processar dados pessoais apenas na medida necessária para os fins do serviço" },
                        { "text": "Garantir que os períodos de retenção de dados pessoais não excedam o tempo necessário" },
                        { "text": "Prevenir fraude ou atividade ilegal" }
                    ]
                },
                {
                    "title": "4. Segurança de Dados",
                    "description": "Implementamos medidas de segurança de padrão industrial para proteger as suas informações pessoais:",
                    "items": [
                        { "text": "Ficheiros encriptados com AES-256 em transmissão e armazenamento" },
                        { "text": "Dados sensíveis processados usando arquitetura de conhecimento zero" },
                        { "text": "Auditoria diária de registos de segurança e verificações de vulnerabilidades" },
                        { "text": "Acesso dos funcionários de acordo com a política de privilégio mínimo" }
                    ]
                },
                {
                    "title": "5. Partilha de Dados",
                    "description": "Não vendemos as suas informações pessoais. Podemos partilhar informações com as seguintes partes:",
                    "items": [
                        { "bold": "Prestadores de serviços", "text": "Limitado ao processamento de dados necessário apenas para fornecer serviços específicos (como armazenamento em nuvem CloundFlare, gateways de pagamento de terceiros como Creem/Stripe/PayPal), e sujeito a acordos de processamento de dados" },
                        { "bold": "Requisitos legais", "text": "Quando recebemos uma intimação válida, ordem judicial ou outro processo legal aplicável a nós" }
                    ]
                },
                {
                    "title": "6. Os Seus Direitos",
                    "description": "De acordo com as leis aplicáveis na sua região, pode ter os seguintes direitos:",
                    "items": [
                        { "text": "Aceder a uma cópia dos seus dados pessoais" },
                        { "text": "Corrigir informações imprecisas ou incompletas" },
                        { "text": "Direito ao apagamento de dados ('direito a ser esquecido'), a menos que tenhamos um motivo legal para retê-los" },
                        { "text": "Opor-se ou restringir certos tipos de processamento de dados" },
                        { "text": "Direito à portabilidade de dados, permitindo-lhe solicitar a transferência dos seus dados" }
                    ]
                },
                {
                    "title": "7. Privacidade Infantil",
                    "description": "Os nossos serviços não se destinam a crianças menores de 16 anos. De acordo com o Artigo 8 do Regulamento Geral sobre a Proteção de Dados (RGPD), o consentimento para crianças menores de 16 anos deve ser dado pelos seus pais ou tutores. Se souber que uma criança menor de 16 anos nos forneceu informações pessoais, entre em contacto connosco imediatamente em support@clixmagic.com."
                },
                {
                    "title": "8. Alterações a Esta Política",
                    "description": "Podemos atualizar esta Política de Privacidade periodicamente. Publicaremos a nova política nesta página e atualizaremos a data de \"última atualização\"."
                },
                {
                    "title": "9. Contacte-nos",
                    "description": "Se tiver alguma dúvida sobre esta Política de Privacidade, por favor contacte-nos através de support@clixmagic.com. Se acredita que os seus dados foram processados inadequadamente ou se tiver outras preocupações, não hesite em contactar-nos a qualquer momento."
                }
            ]
        },
        "cookies": {
            "sections": [
                {
                    "title": "1. O Que São Cookies",
                    "description": "Cookies são pequenos ficheiros de texto colocados no seu computador ou dispositivo móvel quando visita websites. Eles permitem que o website reconheça o seu dispositivo e lembre-se se visitou o site anteriormente."
                },
                {
                    "title": "2. Como Utilizamos Cookies",
                    "description": "ClixMagicAI utiliza cookies para várias finalidades:",
                    "items": [
                        { "bold": "Cookies essenciais", "text": "Necessários para a funcionalidade básica do nosso website (como gestão de sessão e recursos de segurança)" },
                        { "bold": "Cookies de preferência", "text": "Lembram as suas configurações e preferências para melhorar a sua experiência, como lembrar o seu avatar, nome de utilizador, etc. após iniciar sessão com Google ou GitHub" },
                        { "bold": "Cookies analíticos", "text": "Ajudam-nos a entender como os visitantes interagem com o nosso website através da recolha de informações anónimas" },
                        { "bold": "Cookies de marketing", "text": "Fornecem anúncios relevantes para os seus interesses rastreando os seus hábitos de navegação" }
                    ]
                },
                {
                    "title": "3. Tipos de Cookies Que Utilizamos",
                    "subsection": [
                        {
                            "title": "3.1 Cookies Essenciais",
                            "description": "Estes cookies são necessários para o funcionamento adequado do website. Eles permitem funcionalidades principais como segurança, gestão de rede e acesso à conta (incluindo login com Google e GitHub). Pode configurar o seu navegador para bloquear estes cookies, mas algumas partes do site podem não funcionar corretamente."
                        },
                        {
                            "title": "3.2 Cookies de Desempenho e Análise",
                            "description": "Estes cookies recolhem informações anónimas que nos ajudam a entender como os visitantes interagem com o nosso website. Utilizamos estes dados para melhorar o nosso website e serviços. Estes cookies não recolhem informações que possam identificar os visitantes."
                        },
                        {
                            "title": "3.3 Cookies de Funcionalidade",
                            "description": "Estes cookies permitem que o nosso website se lembre das escolhas que fez (como preferências de idioma ou estado de login) para fornecer funcionalidades personalizadas melhoradas, como lembrar o seu estado de login com Google ou GitHub."
                        },
                        {
                            "title": "3.4 Cookies de Direcionamento e Publicidade",
                            "description": "Estes cookies são utilizados para mostrar publicidade relevante aos visitantes e rastrear a eficácia das nossas campanhas publicitárias. Note que, como o nosso website depende principalmente de login de terceiros (Google e GitHub), este tipo de cookies é usado principalmente para melhorar a experiência do utilizador e não para marketing direto."
                        }
                    ]
                },
                {
                    "title": "4. Gestão de Cookies",
                    "description": "Pode controlar e gerir cookies de várias formas. A maioria dos navegadores web permite-lhe gerir as suas preferências de cookies. Pode:",
                    "items": [
                        { "text": "Eliminar cookies do seu dispositivo" },
                        { "text": "Bloquear cookies ativando a configuração no seu navegador que permite recusar todos ou alguns cookies" },
                        { "text": "Configurar o seu navegador para notificá-lo quando receber um cookie" }
                    ]
                },
                {
                    "title": "5. Cookies de Terceiros",
                    "description": "Alguns cookies são colocados por terceiros no nosso website. Estes terceiros podem incluir serviços analíticos (como Google Analytics) e redes de publicidade. Devido à forma como os cookies funcionam (os cookies só são acessíveis pela parte que os definiu originalmente), não controlamos a utilização destes cookies de terceiros nem podemos aceder a eles. Para utilizadores que iniciam sessão através do Google e GitHub, garantiremos seguir as diretrizes de privacidade dessas plataformas ao lidar com informações relacionadas."
                },
                {
                    "title": "6. Atualizações a Esta Política de Cookies",
                    "description": "Podemos atualizar esta política de cookies periodicamente para refletir alterações na tecnologia, regulamentos ou nas nossas práticas comerciais. Quaisquer alterações serão publicadas nesta página e a data de revisão será atualizada."
                },
                {
                    "title": "7. Contacte-nos",
                    "description": "Se tiver alguma dúvida sobre a nossa utilização de cookies, por favor contacte-nos através de support@clixmagic.com."
                }
            ]
        }
    },
}